import React from "react";


import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";

// datatable related plugins
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";

import { connect } from "react-redux";
import PropTypes from "prop-types";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import RemoteTable from "../../../components/Common/RemoteTable";
import SweetAlert from "react-bootstrap-sweetalert";
import styled from "styled-components";
import ModifiedMetaTags from '../../../components/ModifiedMetaTags/index';
import { getServiceProvidersList } from "../../../store/service-provider/actions"
import {
  deleteCampaignCashback,
  getCampaignCashbacksList,
} from "../../../store/campaigns/cashbacks/actions";

class Cashbacks extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      sizePerPage: 10,
      filter_name: [],
      deleteAlert: null,
    };
  }

  componentDidMount() {
    this.props.getCampaignCashbacksList(this.props.data);
    this.props.getServiceProvidersList({
      ...this.props.service_providers,
      sizePerPage: 0,
    })
  }

  handleTableChange = data => {
    data["ordering"] = data["ordering"].includes("geos")
      ? data["ordering"].replace("geos", "countries")
      : data["ordering"];
    data["ordering"] = data["ordering"].includes("dateRange")
      ? data["ordering"].replace("dateRange", "date_from")
      : data["ordering"];
    this.props.getCampaignCashbacksList(data);
  };

  handleChangeDeleteAlert = data => {
    this.setState({ deleteAlert: data });
  };

  render() {
    const actionsFormatter = (cell, row) => {
      const onClickDelete = () => {
        this.handleChangeDeleteAlert({
          title: `Delete "${row.name}"!`,
          onConfirm: () => {
            this.props.deleteCampaignCashback(row.id, {
              ...this.props.data,
              page:
                this.props.data.results.length === 1 ? 1 : this.props.data.page,
            });
            this.handleChangeDeleteAlert(null);
          },
        });
      };

      const onClickEdit = e => {
        onClickRow(e, row);
      };

      return (
        <React.Fragment>
          {this.props.permissions["change_cashbackmodel"] && (
            <Button
              type="button"
              className="btn btn-primary  btn-sm"
              onClick={onClickEdit}
            >
              <i className="mdi mdi-circle-edit-outline d-block font-size-16" />
            </Button>
          )}
          {this.props.permissions["delete_cashbackmodel"] && (
            <Button
              type="button"
              className="btn btn-danger btn-sm m-1"
              onClick={onClickDelete}
            >
              <i className="mdi mdi-trash-can d-block font-size-16" />
            </Button>
          )}
        </React.Fragment>
      );
    };

    const nameFormatter = (cell, row, label) => {
      return (
        <NameLink onClick={e => onClickRow(e, row)}>{row[label]}</NameLink>
      );
    };

    const nameServiceProviderFormatter = (cell, row, label) => {
      let serviceProvider = this.props.service_providers.results.find((item) => item.id === row[label]);
      return (
        <NameLink onClick={e => onClickRow(e, row)}>{serviceProvider?.counterparty_name || 'None'}</NameLink>
      );
    };

    const onClickRow = (e, row) => {
      this.props.history.push(`/cashbacks/${row.id}`);
    };

    const columns = [
      {
        dataField: "name",
        text: "Name",
        sort: true,
        formatter: (cell, row) => nameFormatter(cell, row, "name"),
      },
      {
        dataField: "media_source__name",
        text: "Media source",
        sort: true,
        formatter: (cell, row) => nameFormatter(cell, row, "media_source_name"),
      },
      {
        dataField: "service_provider_id",
        text: "Service provider",
        sort: true,
        formatter: (cell, row) => nameServiceProviderFormatter(cell, row, "service_provider_id"),
      },
      //   {
      //     dataField: "geos",
      //     text: "GEO",
      //     sort: true,
      //     formatter: (cell, row) => nameFormatter(cell, row, "geos"),
      //   },
      {
        dataField: "dateRange",
        text: "Date range",
        sort: true,
        formatter: (cell, row) => nameFormatter(cell, row, "dateRange"),
      },
      {
        dataField: "actions",
        text: "Actions",
        sort: false,
        formatter: actionsFormatter,
      },
    ];

    return (
      <React.Fragment>
        <div className="page-content">
          <ModifiedMetaTags title="Campaign cashbacks  | Mobihunter" />
          <Container fluid>
            <Breadcrumbs
              title="Dashboard"
              breadcrumbItem="Campaign cashbacks"
              link="/dashboard"
            />
            {this.state.deleteAlert && (
              <SweetAlert
                showCancel
                confirmBtnText="Delete"
                cancelBtnText="Cancel"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle=""
                title={this.state.deleteAlert.title}
                onCancel={() => this.handleChangeDeleteAlert(null)}
                onConfirm={this.state.deleteAlert.onConfirm}
              >
                <p>
                  You are about to delete this cashback? <br /> If you are not
                  sure, you can close this form.{" "}
                </p>
              </SweetAlert>
            )}

            <Row>
              <Col className="col-12">
                <Card>
                  <CardBody>
                    <RemoteTable
                      onTableChange={this.handleTableChange}
                      columns={columns}
                      data={this.props.service_providers.results.length > 0 ? this.props.data : { results: [] }}
                      loading={this.props.loading}
                    >
                      {this.props.permissions &&
                        this.props.permissions["add_cashbackmodel"] ===
                        "add_cashbackmodel" && (
                          <Button
                            type="button"
                            color="success"
                            className="btn-rounded mb-2 me-2"
                            onClick={() => {
                              this.props.history.push("/cashbacks/add");
                            }}
                          >
                            <i className="mdi mdi-plus me-1" /> Add campaign
                            cashback
                          </Button>
                        )}
                    </RemoteTable>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const NameLink = styled.div`
  transition-duration: 0.1s;
  &:hover {
    color: rgb(85, 110, 230);
    transition-duration: 0.1s;
  }
`;

Cashbacks.propTypes = {
  data: PropTypes.any,
  loading: PropTypes.bool,
  getCampaignCashbacksList: PropTypes.func,
  deleteCampaignCashback: PropTypes.func,
  history: PropTypes.any,
  permissions: PropTypes.any,
  service_providers: PropTypes.any,
  getServiceProvidersList: PropTypes.func,
};

const mapStateToProps = state => ({
  data: state.CampaignCashbackList.data,
  loading: state.CampaignCashbackList.loading,
  service_providers: state.ServiceProviders.data,
  permissions: state.User.permissions,
});

export default connect(mapStateToProps, {
  getCampaignCashbacksList,
  deleteCampaignCashback,
  getServiceProvidersList,
})(Cashbacks);
